var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tile",class:{ revealed: this.tile.revealed, flag: this.tile.flag },on:{"click":_vm.handleClick,"contextmenu":_vm.handleRightClick}},[_vm._v(" "+_vm._s(_vm.display)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }